import { atom } from "recoil";
import type { ClipStatusTimeline } from "MVVM/Components/ClipStatus/@types";
import { persistAtom } from "./persist";

export const InFlightClipsAtom = atom<ClipStatusTimeline[]>({
  key: "InFlightClips_V0.1",
  default: [],
});

export const PollingActiveAtom = atom<boolean>({
  key: "PollingActive_V0.1",
  default: false,
});

export const TrayUIAtom = atom<{ expanded: boolean; pinnedTrackId?: string }>({
  key: "TrayUI_V0.1",
  default: { expanded: false },
});

export const DismissedTerminalsAtom = atom<Record<string, number>>({
  key: "DismissedTerminals_V0.1",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const ExpandedCardsAtom = atom<Record<string, boolean>>({
  key: "ExpandedCards_V0.1",
  default: {},
});

export const PulseKickAtom = atom<number>({
  key: "PulseKick_V0.1",
  default: 0,
});
